import EventType from "../../../../backend/models/EventType.ts";

export function getBadgeColor(status) {
  switch (status) {
    case 0:
      return "orange";
    case 1:
      return "yellow";
    case 2:
      return "green";
    default:
      return "danger";
  }
}

export function getStatusColor(status) {
  switch (parseInt(status)) {
    case 0:
      return "#f18787";
    case 1:
      return "#f1dc3a";
    case 2:
      return "#52be74";
    default:
      return "#FF0000";
  }
}

export function getStatusText(status) {
  switch (parseInt(status)) {
    case 0:
      return "Nova";
    case 1:
      return "Em processamento";
    case 2:
      return "Concluída";
    default:
      return "Desconhecido";
  }
}

export function labelEventType(type) {
  switch (parseInt(type)) {
    case EventType.FREE_TEXT:
      return "Texto livre";
    case EventType.WITH_ATTACHMENT:
      return "Com anexo";
    case EventType.MONITORING_RESPONSE_ENABLED:
      return "Resposta habilitada";
    case EventType.MONITORING_RESPONSE_DISABLED:
      return "Resposta desabilitada";
    case EventType.TASK:
      return "Tarefa de terceiros";
    case EventType.SOLVE_TASK:
      return "Resposta de Tarefa de terceiros";
    case EventType.PENDENCY:
      return "Pendência";
    case EventType.CLOSURE:
      return "Encerramento da Denúncia";
    case EventType.COMMITTEE:
      return "Edição Comissão de Apuração";
    case EventType.CLASSIFICATION:
      return "Edição Classificação";
    case EventType.REOPEN:
      return "Reabertura de Procedimento";
    case EventType.TIME_COST:
      return "Tempo/Recursos";
    case EventType.DENOUNCED_UNLINK:
      return "Desvinculação de Denunciado";
    case EventType.COURSE_ASSIGNMENT:
      return "Determinação de Curso";
    default:
      return "Tipo desconhecido";
  }
}
